export default function WhiteCardContainer({ children }) {
    return <div className=" sm:rounded-md sm:overflow-hidden">{children}</div>;
}